import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import Message from 'components/text/Message/Message'

import s from './Text.scss'


class HeaderSubNavDropdownText extends PureComponent {

  static propTypes = {
    className: PropTypes.string,
    text: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]).isRequired,
  }

  render() {
    const { className, text } = this.props

    const rootClassName = cx(s.root, className)

    return (
      <div className={rootClassName}>
        <Message tag="div" className={s.text} text={text} />
      </div>
    )
  }
}

export default HeaderSubNavDropdownText
